import {Component, OnInit, ElementRef, OnDestroy, Inject} from '@angular/core';
import {ROUTES} from '../sidebar/sidebar.component';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../../shared/services/api.service';
import {InternalService} from '../../../shared/services/internal.service';
import {CookieService} from 'ngx-cookie-service';
import {TranslateService} from '@ngx-translate/core';
import {any} from 'codelyzer/util/function';
import {OidcSecurityService} from 'angular-auth-oidc-client';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private toggleButton: any;
  private sidebarVisible: boolean;

  public isCollapsed = true;

  closeResult: string;
  role: any;
  // profilePic:any;
  constructor(location: Location,
              private element: ElementRef,
              private router: Router,
              private modalService: NgbModal,
              public apiService: ApiService,
              public oidcSecurityService: OidcSecurityService,
              public translate: TranslateService,
              public internalService: InternalService,
              private cookieservice: CookieService) {
    this.location = location;
    this.sidebarVisible = false;
  }

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    const navbar = document.getElementsByClassName('navbar')[0];
    if (window.innerWidth < 993 && !this.isCollapsed) {
      navbar.classList.add('bg-white');
      navbar.classList.remove('navbar-transparent');
    } else {
      navbar.classList.remove('bg-white');
      navbar.classList.add('navbar-transparent');
    }
  };

  ngOnInit() {
    // if (this.cookieservice.get('dir') != null) {
    //   this.apiService.currentDirection = this.cookieservice.get('dir');
    //   if (this.apiService.currentDirection === 'rtl') {
    //     this.internalService.changeLang('fa-ir', 0);
    //   } else {
    //     this.internalService.changeLang('en-us', 0);
    //   }
    // }
    if(this.cookieservice.get('profilePic')){
      this.internalService.getMd5(this.cookieservice.get('profilePic')).then(result=>{
        this.internalService.profilePic=result;
      });
    }

    window.addEventListener('resize', this.updateColor);
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.subscribe(event => {
      this.sidebarClose();
      const $layer: any = document.getElementsByClassName('close-layer')[0];
      if ($layer) {
        $layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    if (!this.isCollapsed) {
      navbar.classList.remove('navbar-transparent');
      navbar.classList.add('bg-white');
    } else {
      navbar.classList.add('navbar-transparent');
      navbar.classList.remove('bg-white');
    }
  }

  changeLanguage(lang) {
    this.internalService.changeLang(lang, 0);
    if (lang === 'en-us') {
      this.cookieservice.set('dir', 'ltr');
      this.cookieservice.set('lang', '2');


      // when we exit this page, we need to delete the classes .rtl and .menu-on-right
      // from the body tag
      document.body.classList.remove('rtl', 'menu-on-right');
      // we also need to delete the rtl bootstrap, so it does not break the other pages
      // that do not make use of rtl
      document.getElementById('rtl-id').remove();
    } else {
      this.cookieservice.set('dir', 'rtl');
      this.cookieservice.set('lang', '1');
    }
    window.location.reload();
  }

  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const mainPanel = (
      document.getElementsByClassName('main-panel')[0] as HTMLElement
    );
    const html = document.getElementsByTagName('html')[0];
    if (window.innerWidth < 991) {
      mainPanel.style.position = 'fixed';
    }

    setTimeout(()=> {
      toggleButton.classList.add('toggled');
    }, 500);

    html.classList.add('nav-open');

    this.sidebarVisible = true;
  }

  sidebarClose() {
    const html = document.getElementsByTagName('html')[0];
    this.toggleButton.classList.remove('toggled');
    const mainPanel = (
      document.getElementsByClassName('main-panel')[0] as HTMLElement
    );

    if (window.innerWidth < 991) {
      setTimeout(()=> {
        mainPanel.style.position = '';
      }, 500);
    }

    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  }

  sidebarToggle() {
    // const toggleButton = this.toggleButton;
    // const html = document.getElementsByTagName('html')[0];
    const $toggle = document.getElementsByClassName('navbar-toggler')[0];

    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const html = document.getElementsByTagName('html')[0];

    if (this.mobile_menu_visible == 1) {
      // $('html').removeClass('nav-open');
      html.classList.remove('nav-open');
      if ($layer) {
        $layer.remove();
      }
      setTimeout(()=> {
        $toggle.classList.remove('toggled');
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(()=> {
        $toggle.classList.add('toggled');
      }, 430);

      var $layer = document.createElement('div');
      $layer.setAttribute('class', 'close-layer');

      if (html.querySelectorAll('.main-panel')) {
        document.getElementsByClassName('main-panel')[0].appendChild($layer);
      } else if (html.classList.contains('off-canvas-sidebar')) {
        document
          .getElementsByClassName('wrapper-full-page')[0]
          .appendChild($layer);
      }

      setTimeout(()=> {
        $layer.classList.add('visible');
      }, 100);

      $layer.onclick = function() {
        //asign a function
        html.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        $layer.classList.remove('visible');
        setTimeout(()=> {
          $layer.remove();
          $toggle.classList.remove('toggled');
        }, 400);
      }.bind(this);

      html.classList.add('nav-open');
      this.mobile_menu_visible = 1;
    }
  }

  camelize(str) {
    // Split the string at all space characters
    return str.split(' ')
    // get rid of any extra spaces using trim
    //.map(a => a.trim())
    // Convert first char to upper case for each word
      .map(a => a[0].toUpperCase() + a.substring(1))
      // Join all the strings back together
      .join(' ');
  }
  // camelize(str) {
  //   return str.split(' ')
  //   // get rid of any extra spaces using trim
  //   //.map(a => a.trim())
  //   // Convert first char to upper case for each word
  //     .map(a => {
  //       if(a[0] !== undefined){
  //         a[0].toUpperCase() + a.substring(1)
  //       } else {
  //         return str;
  //       }
  //       })
  //     // Join all the strings back together
  //     .join(' ');
  // }

  getTitle() {
    let currentUser;
    const rolesArray = JSON.parse(this.cookieservice.get('currentUserRoles'));
    for (let i = 0; i < rolesArray.length; i++) {
      if (rolesArray.includes('Administrator')) {
        currentUser = 'Administrator';
        break;
      } else if (rolesArray.includes('Admin')) {
        currentUser = 'Admin';
        break;
      } else if (rolesArray.includes('Agent')) {
        currentUser = 'Agent';
        break;
      } else if (rolesArray.includes('Moderator')) {
        currentUser = 'Moderator';
        break;
      } else if (rolesArray.includes('Corroborator')) {
        currentUser = 'Corroborator';
        break;
      } else if (rolesArray.includes('Marketer')) {
        currentUser = 'Marketer';
        break;
      }
    }


    this.translate.get('Menu.' + currentUser).subscribe((response: any) => {
      this.role = response;
      // console.log(response);
    });
    const title = this.cookieservice.get('fullName');

    const titlee = title + ' | ' + this.role;


    // console.log(titlee);
    // var titlee = this.location.prepareExternalUrl(this.location.path());
    // if (titlee.charAt(0) === "#") {
    //     titlee = titlee.slice(1);
    // }
    //
    // for (var item = 0; item < this.listTitles.length; item++) {
    //     if (this.listTitles[item].path === titlee) {
    //         return this.listTitles[item].title;
    //     }
    // }
    return titlee;
  }

  open(content) {
    this.modalService.open(content, {windowClass: 'addEditDel-search'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.updateColor);
  }

  logOut() {
    this.cookieservice.delete('fullName');
    this.cookieservice.delete('userId');
    this.cookieservice.delete('currentUserRoles');
    this.cookieservice.delete('lang');
    this.cookieservice.delete('dir');

    const url = this.oidcSecurityService.getEndSessionUrl();
    this.oidcSecurityService.logoffLocal();
    window.location.assign(url);
     this.oidcSecurityService.logoff((url: 'https://mac.medis.land/account/logout') => any);


  }
}
